// extracted by mini-css-extract-plugin
export default {"wrapper":"Content_wrapper__9gtvX"};